export default __webpack_public_path__ + "static/media/0.db4e4963.png";